import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';

interface ConfirmationDialogProps {
    open: boolean;
    title: string;
    content: React.ReactNode;
    confirmButtonText?: string;
    cancelButtonText?: string;
    loading?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    open,
    title,
    content,
    confirmButtonText = 'Delete',
    cancelButtonText = 'Cancel',
    loading = false,
    onConfirm,
    onCancel,
}) => {
    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle sx={{ fontSize: '1.25rem', fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent dividers color='text.inherit' sx={{ fontSize: '1rem' }}>
                {typeof content === 'string' ? <DialogContentText color='text.inherit' sx={{ fontSize: '1rem' }}>{content}</DialogContentText> : content}
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="inherit" disabled={loading}>{cancelButtonText}</Button>
                <Button onClick={onConfirm} color="error" autoFocus disabled={loading} startIcon={loading ? <CircularProgress size={16} /> : undefined}>
                    {loading ? 'Please wait…' : confirmButtonText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;